import { render, staticRenderFns } from "./GameChat.vue?vue&type=template&id=05cf53ee&"
import script from "./GameChat.vue?vue&type=script&lang=js&"
export * from "./GameChat.vue?vue&type=script&lang=js&"
import style0 from "./GameChat.vue?vue&type=style&index=0&id=05cf53ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports